// react router component
import { useEffect, useRef, useState } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import React from 'react';
//
import "./App.css";
import Assets from "./pages/agent/Assets/Assets";
import AgentDashboard from "./pages/agent/Dashboard/Dashboard";
import OtherSettings from "./pages/agent/setings/OtherSetings";
import Settings from "./pages/agent/setings/Setings";
// import AgentTicketList from "./pages/agent/ticket/List";
import Todo from "./pages/agent/Todo/Todo";
import AgentUpdateTicket from "./pages/agent/ticket/Update";

// page component
import Login from "./pages/authentication/Login";
import RequireAuth from "./pages/authentication/RequireAuth";
import Dashboard from "./pages/user/dashboard/Dashboard";
import TicketList from "./pages/ticket/List";
import NewTicket from "./pages/user/ticket/NewTicket";
import AgentNewTicket from "./pages/agent/ticket/NewTicket";
import UpdateTicket from "./pages/user/ticket/Update";
import Report from "./pages/agent/Report";
import EnhancedTable from "./pages/agent/Report1";
import User from "./pages/agent/User/User";
import UsersList from "./pages/agent/User/UsersList";
import AddUser from "./pages/agent/User/AddUser";
import Vendor from "./pages/agent/Vendor/Vendor";
import EditUser from "./pages/agent/User/EditUser";
import Sla from "./pages/agent/SLA/Sla";
import EmailConfiguration from "./pages/agent/setings/EmailConfiguration";

const Layout = () => {
  return <Outlet />;
};

function App() {
  const [role, setRole] = useState("");
  const useRefApp = useRef(false);
  useEffect(() => {
    if (useRefApp.current === false) {
      const useData = JSON.parse(localStorage.getItem("user"));
      if (useData !== null) {
        setRole(useData.role);
      }
    }
    return () => {
      useRefApp.current = true;
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* public routes */}
        <Route path="login" element={<Login />} />
        <Route path="/" element={<Login />} />
        
        <Route path="user/ticket" element={<RequireAuth allowedRoles={["user"]} />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="new" element={<NewTicket />} />
          <Route path="list" element={<TicketList />} />
          <Route path="list/:ticketID" element={<UpdateTicket />} />
        </Route>

        <Route path="agent" element={<RequireAuth allowedRoles={["agent", "Admin"]} />}>
          <Route path="dashboard" element={<AgentDashboard />} />
          <Route path="new" element={<AgentNewTicket />} />
          <Route path="list" element={<TicketList />} />
          <Route path="list/:ticketID" element={<AgentUpdateTicket />} />
          <Route path="settings" element={<Settings />} />
          <Route path="other-settings" element={<OtherSettings />} />
          <Route path="todo" element={<Todo />} />
          <Route path="assets" element={<Assets />} />
          <Route path="report" element={<Report />} />
          <Route path="user/import" element={<User />} />
          <Route path="user/list" element={<UsersList />} />
          <Route path="user/add" element={<AddUser />} />
          <Route path="user/:userID" element={<EditUser />} />
          <Route path="vendor" element={<Vendor />} />
          <Route path="sla" element={<Sla />} />
          <Route path="email-configuration" element={<EmailConfiguration />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
